import { BASE_NUMBER_OF_GUESTS_FILTER, FILTERS, HOME_FILTERS, NUMBER_OF_GUESTS_FILTER } from '../config';
import { VOYAGE_TYPE_FILTER } from '../constants';
import { FilterDropdownConfig, Variant } from '../types';

const variantToFilters: { [key in Variant]: FilterDropdownConfig[] } = {
	[Variant.Base]: FILTERS,
	[Variant.Home]: HOME_FILTERS,
};

const variantToNumberOfGuestsFilter: { [key in Variant]: FilterDropdownConfig } = {
	[Variant.Base]: BASE_NUMBER_OF_GUESTS_FILTER,
	[Variant.Home]: NUMBER_OF_GUESTS_FILTER,
};

export interface FiltersFlagged {
	voyageType: boolean;
	numberOfGuests: boolean;
}

export const getEnabledFilters = (
	navigationFilters: string[],
	variant: Variant,
	customElements: FilterDropdownConfig[],
	flagControlledFilters: FiltersFlagged,
) => {
	const filtersConfig = variantToFilters[variant];
	let enabledFilters: (FilterDropdownConfig | undefined)[] = [];

	const navEnabledFilters = navigationFilters?.map((filterKey) => {
		const filter = filtersConfig.find((f) => f.key === filterKey);
		if (filter?.key === VOYAGE_TYPE_FILTER.key) {
			return flagControlledFilters.voyageType ? filter : undefined;
		}

		if (filter?.key === NUMBER_OF_GUESTS_FILTER.key) {
			return flagControlledFilters.numberOfGuests ? variantToNumberOfGuestsFilter[variant] : undefined;
		}

		return filter;
	})
		.concat(...customElements)
		.filter((item) => item !== undefined);

	if (navEnabledFilters?.length > 0) {
		enabledFilters = navEnabledFilters;
	}

	if (flagControlledFilters.numberOfGuests && !enabledFilters.some((filter) => filter?.key === NUMBER_OF_GUESTS_FILTER.key)) {
		enabledFilters.push(variantToNumberOfGuestsFilter[variant]);
	}

	return enabledFilters;
};
